import React, { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Spinner,
} from 'reactstrap';
import { toast } from 'react-toastify';

import { adminUpdateBrandRequest } from '../../ReduxToolkit/Reducers/brandRequests';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

const WEBHOOK_URL = 'https://hook.eu1.make.com/ywr54km0c7xl84r1ag5r7quguy8kfm5a';

const AlertJanModal = ({ isOpen, toggle, brandRequest, getBrandRequests }) => {
    const dispatch = useDispatch();
    const [note, setNote] = useState('');
    const user = useSelector((state) => state.auth?.user || {});
    const [emailError, setEmailError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateEmail = (value) => {
        if (!value.trim()) return 'Email address is required.';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value.trim())) return 'Please enter a valid email address.';
        return '';
    };


    const handleClose = () => {
        setNote('');
        setEmailError('');
        toggle();
    };

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true);

            const payload = {
                email: brandRequest?.organization?.user?.[0]?.email?.trim(),
                note: note.trim() || undefined,
                brand_name: brandRequest?.brand_name || undefined,
                brand_request_id: brandRequest?.id || undefined,
            };

            const response = await fetch(WEBHOOK_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error('Webhook request failed.');

            await dispatch(adminUpdateBrandRequest(brandRequest?.id, { alert_jan_sent: note.trim() || 'No note attached' }, user?.name));

            // toast.success('Jan has been alerted successfully.', { autoClose: 3000 });
            handleClose();
        } catch (err) {
            toast.error('Failed to alert Jan. Please try again.', { autoClose: 3000 });
        } finally {
            setIsSubmitting(false);
            getBrandRequests();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={handleClose} centered size="md">
            <ModalHeader toggle={handleClose} style={headerStyle}>
                <div>
                    <div style={titleStyle}>Alert Jan</div>
                    {brandRequest?.brand_name && (
                        <div style={subtitleStyle}>{brandRequest.brand_name}</div>
                    )}
                </div>
            </ModalHeader>

            <ModalBody style={{ padding: '24px' }}>
                {/* <FormGroup>
                    <Label style={labelStyle}>
                        Email Address <span style={{ color: '#dc3545' }}>*</span>
                    </Label>
                    <Input
                        type="email"
                        placeholder="jan@example.com"
                        value={email}
                        onChange={handleEmailChange}
                        invalid={!!emailError}
                        disabled={isSubmitting}
                        style={inputStyle}
                    />
                    <FormFeedback>{emailError}</FormFeedback>
                </FormGroup> */}

                <FormGroup className="mb-0">
                    <Label style={labelStyle}>
                        Note{' '}
                        <span style={{ fontSize: '12px', color: '#999', fontWeight: 400 }}>(optional)</span>
                    </Label>
                    <Input
                        type="textarea"
                        placeholder="Add a note for Jan..."
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        disabled={isSubmitting}
                        rows={4}
                        style={{ ...inputStyle, resize: 'vertical' }}
                    />
                </FormGroup>
            </ModalBody>

            <ModalFooter style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0', gap: '8px' }}>
                <Button color="light" onClick={handleClose} disabled={isSubmitting}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    className="d-flex align-items-center gap-2"
                >
                    {isSubmitting && <Spinner size="sm" />}
                    {isSubmitting ? 'Sending...' : 'Submit'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

/* ── Styles ── */

const headerStyle = {
    borderBottom: '1px solid #f0f0f0',
    padding: '20px 24px 16px',
};

const titleStyle = {
    fontSize: '17px',
    fontWeight: 600,
    color: '#1a1a1a',
    lineHeight: 1.3,
};

const subtitleStyle = {
    fontSize: '13px',
    color: '#888',
    fontWeight: 400,
    marginTop: '2px',
};

const labelStyle = {
    fontSize: '13px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '6px',
};

const inputStyle = {
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ddd',
};

export default AlertJanModal;